var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9268 1.61035H1.70215V17.0121H27.9268V1.61035Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87891 1.5332C6.8823 2.2125 6.75144 2.88577 6.49384 3.51433C6.23623 4.1429 5.85696 4.71436 5.37782 5.1959C4.89868 5.67744 4.32911 6.05955 3.70184 6.32029C3.07457 6.58102 2.40196 6.71524 1.72266 6.71523",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02832 17.0127C7.02154 15.6473 6.47612 14.3397 5.5106 13.3742C4.54508 12.4086 3.2375 11.8632 1.87207 11.8564",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.832 1.5332C22.832 2.90756 23.378 4.22563 24.3498 5.19745C25.3216 6.16927 26.6397 6.71523 28.0141 6.71523",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 17.0127C22.7568 15.6473 23.3022 14.3397 24.2677 13.3742C25.2332 12.4086 26.5408 11.8632 27.9062 11.8564",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6797 4.49805H13.9842C15.2681 4.49805 16.6809 4.9157 16.6809 6.86992C16.6809 8.98914 14.8866 9.79867 12.9787 9.58211C12.9562 9.57946 12.9334 9.58396 12.9136 9.59496C12.8938 9.60596 12.8779 9.6229 12.8682 9.64341C12.8585 9.66392 12.8555 9.68696 12.8596 9.70926C12.8637 9.73157 12.8747 9.75202 12.8911 9.76774L16.9439 14.1402",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2335 4.49805H13.7012",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7412 6.93652H18.2636",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCollection);
export default __webpack_public_path__ + "static/media/default_collection.a57c610c72e1328e68ce64be6eeea33d.svg";
export { ForwardRef as ReactComponent };